import React from 'react'
import ActivitiesScreen from "./ActivitiesScreen"
import BirthdayScreen from "./BirthdayScreen"
//import EmployeeWeekScreen from "./EmployeeWeekScreen"
import PunctualityScreen from "./PunctualityScreen"
import HarvestScreen from './harvestRanking'
import firebase from 'firebase/compat/app'
import 'firebase/compat/database';

class Rangerscreen extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            nextPage: 'ActivitiesScreen',
            cumple: [false, 1500],
            pendientes: [false, 1500],
            pisca: [false, 1500],
            puntualidad: [false, 1500],
        };
    }
    componentDidMount() {
        this.getData()
    }
    componentDidUpdate(){
        this.getData()
    }
    getData = async () => {
        try {
            const snapShot = await firebase.firestore().collection('Info').doc('tele').get()
            this.setState({
                cumple: snapShot.data().cumple,
                pendientes: snapShot.data().pendientes,
                pisca: snapShot.data().pisca,
                puntualidad: snapShot.data().puntualidad,
                paginas: ['ActivitiesScreen', 'BirthdayScreen', 'PunctualityScreen', 'PunctualityScreen', 'HarvestScreen'],
                contador: 0
            })
            if (!snapShot.data().cumple[0] && 
                !snapShot.data().pendientes[0] &&
                !snapShot.data().pisca[0] &&
                !snapShot.data().puntualidad[0] )
                {this.setState({nextPage: "default"})}
        }
        catch (e) {
            console.log(e.message)
            if (e.message === 'Failed to get document because the client is offline.') {
                return this.getData()
            }
        }
    }

    ChangeToNextPage = () => {
        if (this.state.contador < 5) {
            this.setState({ 
                nextPage: this.state.paginas[this.state.contador],
                contador: this.state.contador + 1 
            })
        } else {
            this.setState({ 
                contador: 0 
            })
        }
        console.log('contador: '+this.state.contador)
    }

    renderSwitch(page) {
        switch(page) {
            case 'ActivitiesScreen':
                return (
                    <ActivitiesScreen nextPageProp={this.ChangeToNextPage} 
                        active={this.state.pendientes[0]} 
                        time={this.state.pendientes[1]}
                    />
                );
            case 'BirthdayScreen':
                return (
                    <BirthdayScreen nextPageProp={this.ChangeToNextPage} 
                        active={this.state.cumple[0]} 
                        time={this.state.cumple[1]}
                    />
                )
            case 'PunctualityScreen':
                return (
                    <PunctualityScreen nextPageProp={this.ChangeToNextPage} 
                        active={this.state.puntualidad[0]} 
                        time={this.state.puntualidad[1]}
                    />
                )
            case 'HarvestScreen':
                return (
                    <HarvestScreen nextPageProp={this.ChangeToNextPage}
                        active={this.state.pisca[0]} 
                        time={this.state.pisca[1]}
                    />
                )
          default:
            return (
                <h1>Todas las secciones estan desactivadas.</h1>   
               );
        }
    }
    
    render() {
        return (
            <div>
                {this.renderSwitch(this.state.nextPage)}
            </div>
        )
        /*
          else if (this.state.nextPage === 'EmployeeWeekScreen') {
            return (
              <EmployeeWeekScreen nextPageProp={this.ChangeToNextPage} />
            )
           */
    }
}

export default Rangerscreen;